import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { Toaster } from "@/components/ui/sonner";
import { ConsultationProvider } from "@/components/ConsultationModal";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import HomePage from "@/pages/HomePage";
import AboutPage from "@/pages/AboutPage";
import ServicesPage from "@/pages/ServicesPage";
import AssociateNetworkPage from "@/pages/AssociateNetworkPage";
import WinePage from "@/pages/WinePage";
import WebDesignPage from "@/pages/WebDesignPage";
import ContactPage from "@/pages/ContactPage";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function AppLayout() {
  return (
    <>
      <ScrollToTop />
      <Navbar />
      <main className="pt-20">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/services" element={<ServicesPage />} />
          <Route path="/associate-network" element={<AssociateNetworkPage />} />
          <Route path="/wine" element={<WinePage />} />
          <Route path="/web-design" element={<WebDesignPage />} />
          <Route path="/contact" element={<ContactPage />} />
        </Routes>
      </main>
      <Footer />
    </>
  );
}

function App() {
  return (
    <BrowserRouter>
      <ConsultationProvider>
        <AppLayout />
        <Toaster
          position="bottom-right"
          toastOptions={{
            className: 'rounded-none font-body',
          }}
        />
      </ConsultationProvider>
    </BrowserRouter>
  );
}

export default App;
